<div class="atendimento-form">
  <form [formGroup]="enviarMensagemForm" style="margin-bottom: 3rem;" (ngSubmit)="onSubmit()" (keyup.enter)="onSubmit()">
    <h3 class="titulo-envie-mensagem">Envie sua mensagem!</h3>

    <lib-segov-sigepo-field
      [fieldId]="'nome'"
      [titleStyle]="'color: var(--tom-2-informativo); font-weight: 600;'"
      [fieldTitle]="'Nome:*'" [parent]="enviarMensagemForm"
      [fieldFormControl]="enviarMensagemForm.controls['nome']"
      [inputFieldStyle]="'height: 64px; border: 1px solid; margin: 1rem 0 1rem 0;'"
      [readyShowError]="true"
      [maxLength]="100">
    </lib-segov-sigepo-field>

    <lib-segov-sigepo-field
      [fieldId]="'email'"
      [titleStyle]="'color: var(--tom-2-informativo); font-weight: 600;'"
      [fieldTitle]="'E-mail:*'" [parent]="enviarMensagemForm"
      [fieldFormControl]="enviarMensagemForm.controls['email']"
      [inputFieldStyle]="'height: 64px; border: 1px solid; margin: 1rem 0;'"
      [placeHolderText]="'nome@dominio.com'"
      [readyShowError]="true"
      [maxLength]="100">
    </lib-segov-sigepo-field>

    <lib-segov-sigepo-field
      [fieldId]="'telefone'"
      [titleStyle]="'color: var(--tom-2-informativo); font-weight: 600;'"
      [fieldTitle]="'Telefone:'" [parent]="enviarMensagemForm"
      [fieldFormControl]="enviarMensagemForm.controls['telefone']"
      [inputFieldStyle]="'height: 64px; border: 1px solid; margin: 1rem 0;'"
      [fieldType]="'mask'"
      [fieldMask]="'(00)0 0000-0000'"
      [placeHolderText]="'(31)9 9999-9999'"
      [isRequired]="false"
      [readyShowError]="true">
    </lib-segov-sigepo-field>

    <lib-segov-sigepo-combo-box
      [fieldId]="'tipoManifestacao'"
      [titleStyle]="'color: var(--tom-2-informativo); font-weight: 600;'"
      [fieldTitle]="'Tipo de manifestação:*'" [parent]="enviarMensagemForm"
      [selectStyle]="'height: 64px; border: 1px solid; margin: 1rem 0;'"
      [fieldFormControl]="enviarMensagemForm.controls['tipoManifestacao']"
      [items]="tiposManifestacao"
    >
    </lib-segov-sigepo-combo-box>

    <lib-segov-sigepo-field
      class="textarea-box"
      [fieldId]="'mensagemEmail'"
      [titleStyle]="'color: var(--tom-2-informativo); font-weight: 600;'"
      [fieldType]="'textarea'"
      [inputFieldStyle]="'height: 316px; border: 1px solid; margin: 1rem 0;'"
      [customStyle]="'background-color: white'"
      [fieldTitle]="'Mensagem:*'" [parent]="enviarMensagemForm"
      [fieldFormControl]="enviarMensagemForm.controls['mensagem']"
      [readyShowError]="true"
      [maxLength]="3000">
    </lib-segov-sigepo-field>

    <div style="display: flex; justify-content: center;">
      <lib-segov-sigepo-rounded-button
          [baseStyle]="'segov-rounded-button-with-border'"
          [disabled]="!enviarMensagemForm.valid"
          [type]="'submit'"
          [customStyle]="enviarMensagemForm.valid ? 'font-weight:700; height: 48px; width:280px; letter-spacing: 1px; border-radius: 5px; background-color: var(--tom-2-informativo)' : 'font-weight:700; height: 48px; width:280px; letter-spacing: 1px; border-radius: 5px;'">
            Enviar mensagem
        </lib-segov-sigepo-rounded-button>
    </div>
  </form>
</div>
